'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	config = require('@mindmup/config'),
	AjaxPromise = require('../models/ajax-promise'),
	authenticationAWSStart = require('../features/authentication/authentication-aws-start'),
	cognitoStart = require('../features/cognito/cognito-start'),
	defaultMapContent = require('../models/default-map-content'),
	GoldAWSApi = require('../models/gold-aws-api'),
	NavigatorShim  = require('../widgets/navigator-shim'),
	TaskRetrier = require('../models/task-retrier'),
	AjaxNetworkErrorRetrier = require('../models/ajax-network-error-retrier'),
	GooglePicker = require('../models/google-picker'),
	personalSignupStart = require('../features/signup/personal-signup-start'),
	S3Api = require('../models/s3-api'),
	S3FileModel = require('../models/s3-file-model'),
	pageActionsStart = require('../features/page-actions-start'),
	SubscriptionPlanModel = require('../models/subscription-plan-model'),
	AjaxPromiseErrorAdapter = require('../models/ajax-promise-error-adapter'),
	plans = require('../models/plans'),
	googleAjaxErrorConverter = require('../models/google-ajax-error-converter'),
	googleMigrationStart = (authenticationModel, googleShim,  goldApi, googleContainer, googleAjaxProvider, navigatorShim, ajaxPromise, s3FileModel) => {
		if (!config || !authenticationModel || !googleShim || !goldApi || !googleContainer) {
			throw new Error('invalid-args');
		}
		const GoogleMigrationModel = require('../models/google-migration-model'),
			GoogleDriveService = require('../models/google-drive-service'),
			GoogleDriveResumableUploader = require('../models/google-drive-resumable-uploader'),
			GoogleAuthenticator = require('../models/google-authenticator'),
			OAuthApi =  require('../models/oauth-api'),
			GoogleRTFile = require('../models/google-rt-file'),
			GapiScriptLoader = require('../models/gapi-script-loader'),
			CollaborationModel = require('../models/collaboration-model'),
			collaborationModel = new CollaborationModel(),
			googlePicker = new GooglePicker(config, googleContainer),
			IconLocaliser = require('../models/icon-localiser'),
			AssetLocaliser = require('../models/asset-localiser'),
			CorsProxyFallbackDownloader = require('../models/cors-proxy-fallback-downloader'),
			corsProxyFallbackDownloader = new CorsProxyFallbackDownloader(config, navigatorShim, ajaxPromise, '/assets/image-placeholder.svg'),
			iconLocaliser = new IconLocaliser(corsProxyFallbackDownloader),
			assetLocaliser = new AssetLocaliser([iconLocaliser.localiseSingleIcon]),
			googleAuthApi = new OAuthApi(googleShim),
			googleRTFile = new GoogleRTFile(config, collaborationModel, googleAjaxProvider),
			migrationAuthenticator = new GoogleAuthenticator(googleAuthApi, goldApi, 'google-drive', {scope: config.driveScope.startup}, {allowUnlicensed: true}),
			googleDriveService = new GoogleDriveService(googleAjaxProvider, googleShim, new GoogleDriveResumableUploader(), navigatorShim),
			googleMigrationModel = new GoogleMigrationModel(config, authenticationModel, migrationAuthenticator, googlePicker, googleRTFile, assetLocaliser, s3FileModel, googleDriveService),
			gapiScriptLoader = new GapiScriptLoader(config, window, navigatorShim);



		return {
			googleMigrationModel: googleMigrationModel,
			start: () => {
				return gapiScriptLoader.ensureEditorScripts()
				.then(() => console.log('gapi loaded'))
				.catch(console.trace);
			},
			initialiseWidgets: () => {
				require('../widgets/dispatched-event-toggle-widget');
				mmWidgets('[data-mm-google-migration-context]').dispatchedEventToggleWidget(googleMigrationModel, ['context'], 'data-mm-google-migration-context', 'context-value', 'context-toggle-class');
				require('../widgets/google-migration-list-widget');
				mmWidgets('[data-mm-role~="google-migration-list"]').googleMigrationListWidget(googleMigrationModel);
				mmWidgets('[data-mm-migration-value]').dispatchedEventValueWidget(googleMigrationModel, ['context'], 'mm-migration-value');
			}
		};
	};


require('../widgets/user-profile-widget');
require('../widgets/visibility-observer');
require('../widgets/menu-bar-widget');
require('../widgets/macify-hotkeys-widget');
require('../widgets/install-hotkey-widget');
require('../widgets/show-hotkey-widget');
require('../widgets/subscription-profile-widget');
require('../widgets/context-menu-widget');
require('../widgets/context-disabler-widget');
module.exports = function migrateFromGoogle() {
	const navigatorShim = new NavigatorShim(),
		subscriptionPlanModel = new SubscriptionPlanModel(plans(config.allowedAccountTypes)),
		ajaxPromise = new AjaxPromise(navigatorShim),
		goldApi = new GoldAWSApi(ajaxPromise, config.goldAWSApiUrl),
		googleAjaxProvider = new AjaxPromiseErrorAdapter(ajaxPromise, googleAjaxErrorConverter),
		taskRetrier = new TaskRetrier(navigatorShim),
		googleAjaxNetworkErrorRetrier = new AjaxNetworkErrorRetrier(3, googleAjaxProvider, taskRetrier),
		authentication = authenticationAWSStart(config, goldApi, navigatorShim, window, ajaxPromise),
		s3Api = new S3Api(navigatorShim, ajaxPromise),
		s3FileModel = new S3FileModel(config, authentication, goldApi, s3Api, navigatorShim, defaultMapContent),
		cognito = cognitoStart(config, goldApi, authentication.subscriptionModel, authentication.authenticationModel, authentication.reauthenticator, navigatorShim),
		googlePicker = new GooglePicker(config,  window),
		googleMigration = googleMigrationStart(authentication.authenticationModel, authentication.googleShim, goldApi, window, googleAjaxNetworkErrorRetrier, navigatorShim, ajaxPromise, s3FileModel),
		components = {
			googleMigrationModel: googleMigration.googleMigrationModel,
			pageController: googleMigration.googleMigrationModel,
			googlePicker: googlePicker,
			s3FileModel: s3FileModel,
			authenticationModel: authentication.authenticationModel,
			googleAuthenticator: authentication.googleAuthenticator,
			cognito: cognito,
			subscriptionModel: authentication.subscriptionModel
		},
		container = document.querySelector('[data-mm-role~="fileList"]');
	personalSignupStart(config, authentication.subscriptionModel, subscriptionPlanModel, authentication.authenticationModel, navigatorShim, s3Api, goldApi);
	pageActionsStart(components, container);

	authentication.authenticationModel.addEventListener('authenticatedProfile not-authenticated', (reason) => {
		if (reason === 'signed-out') {
			navigatorShim.redirect('/');
			return;
		}
	});
	mmWidgets('[data-mm-hotkey]').macifyHotkeys(navigatorShim);
	mmWidgets('mapmenu').menuBarWidget(navigatorShim);
	mmWidgets('[data-mm-show-hotkey]').showHotkeyWidget(mmWidgets('body'));
	mmWidgets('[data-mm-install-hotkey]').installHotkeyWidget();
	mmWidgets('[data-mm-subscription-profile]').subscriptionProfileWidget(authentication.subscriptionModel);
	window.components = components;
	googleMigration.initialiseWidgets();

	googleMigration.start()
	.then(() => authentication.reauthenticator.reauthenticate())
	.catch(() => true);
};

